import React, { useState } from 'react';
import styled from 'styled-components';
import { Routes } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { Theme } from '@mui/material';

import { renderRedirects, renderRoutes } from '@lib/router';

import { fetchTheme } from '@modules/shared/helpers';
import { Loader } from '@modules/layout/moleculas';
import { GlobalStyles, ThemeProvider } from '@strategicclaimsmassarb/modules/ui/theme';
import {
    redirects as configRedirects,
    routes as configRoutes,
} from '@strategicclaimsmassarb/config/routes';
import { SnackBarProvider } from '@modules/ui/core';
import { AppProps } from '@modules/types';

const Root = styled.div``;

const StrategicClaimsMassArbApp = ({ basename }: AppProps): React.ReactElement => {
    const routes = Object.values(configRoutes);
    const redirects = Object.values(configRedirects);

    const [tenantTheme, setTenantTheme] = useState<Theme | null>(null);

    React.useEffect(() => {
        const setupTheme = async () => {
            const fetchedTheme = await fetchTheme();

            setTenantTheme(fetchedTheme);
        };

        setupTheme();
    }, []);

    if (!tenantTheme) {
        return (
            <Root>
                <GlobalStyles />
                <Loader />
            </Root>
        );
    }

    return (
        <ThemeProvider theme={tenantTheme}>
            <SnackBarProvider>
                <GlobalStyles theme={tenantTheme} />

                <BrowserRouter basename={basename}>
                    <Routes>
                        {renderRoutes(routes)}
                        {renderRedirects(redirects)}
                    </Routes>
                </BrowserRouter>
            </SnackBarProvider>
        </ThemeProvider>
    );
};

export default StrategicClaimsMassArbApp;
